var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdea(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 49.9998,
    r: 50,
    fill: "#D7BBF9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 47.9998H36M64 47.9998C65.0609 47.9998 66.0783 48.4212 66.8284 49.1714C67.5786 49.9215 68 50.939 68 51.9998V63.9998C68 65.0607 67.5786 66.0781 66.8284 66.8282C66.0783 67.5784 65.0609 67.9998 64 67.9998H36C34.9391 67.9998 33.9217 67.5784 33.1716 66.8282C32.4214 66.0781 32 65.0607 32 63.9998V51.9998C32 50.939 32.4214 49.9215 33.1716 49.1714C33.9217 48.4212 34.9391 47.9998 36 47.9998M64 47.9998V43.9998C64 42.939 63.5786 41.9215 62.8284 41.1714C62.0783 40.4212 61.0609 39.9998 60 39.9998M36 47.9998V43.9998C36 42.939 36.4214 41.9215 37.1716 41.1714C37.9217 40.4212 38.9391 39.9998 40 39.9998M60 39.9998V35.9998C60 34.939 59.5786 33.9215 58.8284 33.1714C58.0783 32.4212 57.0609 31.9998 56 31.9998H44C42.9391 31.9998 41.9217 32.4212 41.1716 33.1714C40.4214 33.9215 40 34.939 40 35.9998V39.9998M60 39.9998H40",
    stroke: "#59595C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdea);
export default __webpack_public_path__ + "static/media/idea.b7acc6ba960d66eb6126393a8fd8bada.svg";
export { ForwardRef as ReactComponent };